import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ChipDateRangeSelectData } from '@sb/library/base';
import { FormFieldDateBaseComponent } from '@sb/library/form-field';
import { SBDate } from '@sb/library/localization';
import { MbscDateType, MbscDatepicker, MbscDatepickerChangeEvent } from '@mobiscroll/angular';

@Component({
    selector: 'lib-chip-date-range-select-panel',
    templateUrl: './chip-date-range-select-panel.component.html',
    styleUrls: ['./chip-date-range-select-panel.component.scss']
})
export class ChipDateRangeSelectPanelComponent extends FormFieldDateBaseComponent<SBDate | null> {
    @ViewChild(MbscDatepicker, {static: true}) datePicker!: MbscDatepicker;

    @Output() dateChange: EventEmitter<SBDate[] | null> = new EventEmitter();
    @Output() menuSelectionChanged: EventEmitter<ChipDateRangeSelectData | null> = new EventEmitter(); //emits null for menu not selected
    @Output() closeMenu: EventEmitter<void> = new EventEmitter();

    @Input() dateOptions!: ChipDateRangeSelectData[];
    @Input() resetDateRange!: SBDate[] | null;

    private _currentSelection!: ChipDateRangeSelectData | null;

    @Input() endDate!: SBDate | null;
    @Input() startDate!: SBDate | null;

    override ngAfterViewInit(): void {
        this.UpdateDatePicker();
    }

    SelectOption(option: ChipDateRangeSelectData): void {
        if (option.DateRange) {
            this.UpdateStartEndDate(SBDate.FromISO(option.DateRange[0]), SBDate.FromISO(option.DateRange[1]));
            this.MenuSelectionChanged(option);
        }
    }

    ResetDateRange(): void {
        this.UpdateStartEndDate();
        this.MenuSelectionChanged();
    }

    DateChanged(event: MbscDatepickerChangeEvent): void {
        const value = event.value as MbscDateType[];
        if (value && value[0]) {
            this.UpdateStartEndDate(SBDate.FromJSDate(value[0] as Date), value[1] ? SBDate.FromJSDate(value[1] as Date) : null);
            this.MenuSelectionChanged();
        };
    }

    UpdateDatePicker(): void {
        if (this.datePicker) {
            this.datePicker.setVal([this.startDate ? this.startDate.ToISO() : null, this.endDate ? this.endDate.ToISO() : null]);
        }
    }

    MenuSelectionChanged(value: ChipDateRangeSelectData | null = null): void {
        this._currentSelection = value;
        this.menuSelectionChanged.emit(value);
    }

    UpdateStartEndDate(startDate: SBDate | null = null, endDate: SBDate | null = null): void {
        this.startDate = startDate;
        this.endDate = endDate;

        // menu should close after 2nd click
        if (startDate && endDate) {
            this.dateChange.emit([startDate, endDate]);
            this.closeMenu.emit();
        } else if (startDate && !endDate) {
            this.dateChange.emit([startDate, startDate]);
        } else if (!startDate && !endDate) {
            this.dateChange.emit(null);
        }

        this.UpdateDatePicker();
    }

    get currentSelection(): ChipDateRangeSelectData | null {
        return this._currentSelection;
    }

    set currentSelection(value: ChipDateRangeSelectData | null) {
        this._currentSelection = value;
    }

    get startSBDate(): SBDate | null {
        return this.startDate;
    }

    get endSBDate(): SBDate | null {
        return this.endDate;
    }

}
